var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('input',{attrs:{"type":"button","value":"Submit"},on:{"click":function($event){return _vm.checkForm()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }